module.exports = __webpack_public_path__ + "static/media/proposal.a4320031.svg";